/* eslint-disable consistent-return */
import eventQueue from '../queue';
import { EventAction, EventType } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var _b, _c;
        var data = _a.data, fireAnalyticsEvent = _a.fireAnalyticsEvent, state = _a.state;
        var fireContinueEvent = function (eventParams, eventType) { return fireAnalyticsEvent(EventAction.CONTINUE, eventParams, eventType); };
        var ddForm = state.ddForm;
        if (data.eventId === 'JobForm-continue' ||
            data.eventId === 'TemplateForm-continue' ||
            data.eventId === 'IntroScreen-continue' ||
            data.eventId === 'TemplateConfirmation-continue' ||
            data.eventId === 'AmountSelection-continue' ||
            data.eventId === 'GuidedSwitchPrimerScreen-continue' ||
            data.eventId === 'ReturnToSearch-continue' ||
            data.eventId === 'TemplateAppClip-continue') {
            return fireContinueEvent({});
        }
        if (data.eventId === 'DDForm-accountSelection') {
            return fireContinueEvent({
                allocation: {
                    amountSelection: state.amountSelection,
                    targets: ddForm.bankInfos,
                },
            }, EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT);
        }
        if (data.eventId === 'MSE-continueNoResults') {
            return fireContinueEvent({});
        }
        if (data.eventId === 'MSE-selectProvider') {
            return fireContinueEvent({
                platformIdOverride: (_b = state.providerEntity.selectedPlatform) === null || _b === void 0 ? void 0 : _b.id,
                employerIdOverride: (_c = state.providerEntity.selectedEmployer) === null || _c === void 0 ? void 0 : _c.id,
            });
        }
    });
}
attachEventListeners();
